import React from 'react';
import {FeedbackTriggerType} from 'records/FeedbackTrigger';
import withRecipients from 'components/triggers/rule-context/WithRecipients';
import ListensContextView from 'components/triggers/rule-context/ListensContextView';
import {SmartAlertContextTitle} from 'components/triggers/rule-context/SmartAlertContextTitle';
import {UserHeadsetIcon} from '@components/icon/UserHeadsetIcon';

class ListensContext extends React.Component {
  constructor(props) {
    super(props);
    this.onValueChange = this.onValueChange.bind(this);

    this.getListens = this.getListens.bind(this);
    this.getListensIndex = this.getListensIndex.bind(this);

    this.addListenContext = this.addListenContext.bind(this);
    this.removeListenContext = this.removeListenContext.bind(this);
    this.state = {userContextSelected: false};
  }

  addListenContext() {
    const listensIndex = this.getListensIndex();
    const newContext = this.props.context.updateIn(['matchAll', listensIndex, 'range'], range => ({
      start: 0,
      end: 100,
    }));
    this.props.contextChange(newContext);
  }

  removeListenContext() {
    const listensIndex = this.getListensIndex();
    this.props.contextChange(
      this.props.context.updateIn(['matchAll', listensIndex, 'range'], range => null)
    );
  }

  getListens() {
    return this.props.context.matchAll.find(item => item.type === FeedbackTriggerType.LISTENS);
  }

  getListensIndex() {
    const listens = this.getListens();
    return this.props.context.matchAll.indexOf(listens);
  }

  onValueChange(range) {
    const listensIndex = this.getListensIndex();
    const newContext = this.props.context.setIn(['matchAll', listensIndex, 'range'], range);
    this.props.contextChange(newContext);
  }

  render() {
    const {usersEmpty, renderEmbeddedContent, showContextButton} = this.props;
    const listens = this.getListens();
    const narrow = !listens.range && usersEmpty;
    return (
      <div className="context-container">
        <SmartAlertContextTitle icon={UserHeadsetIcon} onClose={this.props.removeContext}>
          <span>they listened to the call</span>
        </SmartAlertContextTitle>
        <div className={narrow && 'initial-options'}>
          {renderEmbeddedContent()}
          {showContextButton && (
            <ListensContextView
              context={listens}
              valueChange={this.onValueChange}
              removeItem={this.removeListenContext}
              addItem={this.addListenContext}
            />
          )}
        </div>
      </div>
    );
  }
}

export default withRecipients(ListensContext);
